(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabDomainsDetailController', TabDomainsDetailController);

    TabDomainsDetailController.$inject = ['$scope', '$rootScope', 'entity', 'DataUtils'];

    function TabDomainsDetailController($scope, $rootScope, entity, DataUtils) {
        var vm = this;
        vm.tabDomains = entity;

        var unsubscribe = $rootScope.$on('jotApp:tabDomainsUpdate', function (event, result) {
            vm.tabDomains = result;
        });
        $scope.$on('$destroy', unsubscribe);

        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

    }
})();
